import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class ServiceListUseCase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult(req) {
        return await this.repo.getServiceList(req);
    }
}
export default ServiceListUseCase;
